export const AccordionIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path
      d='M53 60C53 56.134 56.134 53 60 53H340C343.866 53 347 56.134 347 60V240C347 243.866 343.866 247 340 247H60C56.134 247 53 243.866 53 240V60Z'
      fill='white'
    />
    <path
      d='M316.41 80.4102L321 75.8302L325.59 80.4102L327 79.0002L321 73.0002L315 79.0002L316.41 80.4102Z'
      fill='#718096'
    />
    <path
      d='M325.59 169.59L321 174.17L316.41 169.59L315 171L321 177L327 171L325.59 169.59Z'
      fill='#718096'
    />
    <path
      d='M325.59 217.59L321 222.17L316.41 217.59L315 219L321 225L327 219L325.59 217.59Z'
      fill='#718096'
    />
    <path
      d='M71 77C71 73.6863 73.6863 71 77 71H281C284.314 71 287 73.6863 287 77C287 80.3137 284.314 83 281 83H77C73.6863 83 71 80.3137 71 77Z'
      fill='#38B2AC'
    />
    <path
      d='M71 173C71 169.686 73.6863 167 77 167H281C284.314 167 287 169.686 287 173C287 176.314 284.314 179 281 179H77C73.6863 179 71 176.314 71 173Z'
      fill='#A0AEC0'
    />
    <path
      d='M71 221C71 217.686 73.6863 215 77 215H281C284.314 215 287 217.686 287 221C287 224.314 284.314 227 281 227H77C73.6863 227 71 224.314 71 221Z'
      fill='#A0AEC0'
    />
    <path
      d='M71 106C71 103.791 72.7909 102 75 102H318C320.209 102 322 103.791 322 106C322 108.209 320.209 110 318 110H75C72.7909 110 71 108.209 71 106Z'
      fill='#CBD5E0'
    />
    <path
      d='M71 127C71 124.791 72.7909 123 75 123H295C297.209 123 299 124.791 299 127C299 129.209 297.209 131 295 131H75C72.7909 131 71 129.209 71 127Z'
      fill='#CBD5E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M347 149L53 149V148L347 148V149Z'
      fill='#CBD5E0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M347 197L53 197V196L347 196V197Z'
      fill='#CBD5E0'
    />
  </svg>
)
